import { createRoutine } from 'redux-saga-routines';
export const createPayPalManualFundingAccount = createRoutine('@funding/CREATE_PAYPAL_MANUAL_FUNDING_ACOUNT');
